import { request } from '@umijs/max';

// 获取商户日志分页列表
export async function getShopLogPage(params: API.PageParams) {
  return request('/api/admin/shopLog/page', {
    method: 'POST',
    data: params,
  });
}
